import {
  Package,
  Truck,
  MapPin,
  Box,
  Warehouse,
  Ship,
  Plane,
  Bike,
  Container,
  PackageCheck,
  Route,
  Navigation,
  Boxes,
  PackageOpen,
  Compass,
} from "lucide-react";

const ICONS = [
  Package,
  Truck,
  MapPin,
  Box,
  Warehouse,
  Ship,
  Plane,
  Bike,
  Container,
  PackageCheck,
  Route,
  Navigation,
  Boxes,
  PackageOpen,
  Compass,
];

const SIZES = ["h-5 w-5", "h-6 w-6", "h-8 w-8", "h-10 w-10", "h-6 w-6", "h-7 w-7"];

const ROTATIONS = ["rotate-0", "rotate-6", "-rotate-6", "rotate-12", "-rotate-12", "rotate-3", "-rotate-3"];

export function LogisticsIconsBg({ count = 90, className = "" }: { count?: number; className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 overflow-hidden text-white/[0.08] select-none ${className}`}
    >
      <div className="flex h-full flex-wrap content-start items-center gap-x-6 gap-y-6 p-4">
        {Array.from({ length: count }).map((_, i) => {
          const Icon = ICONS[(i * 7) % ICONS.length];
          return (
            <Icon
              key={i}
              className={`${SIZES[(i * 3) % SIZES.length]} ${ROTATIONS[(i * 5) % ROTATIONS.length]} shrink-0`}
              strokeWidth={1.5}
            />
          );
        })}
      </div>
    </div>
  );
}
